/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface UpdateVoiceRequest {
  name?: string;
  description?: string;
  /** @pattern ^(male|female|non-binary|unknown)$ */
  gender?: string;
}

export interface Language {
  language?: string;
  previewUrl?: string;
}

export interface VoiceView {
  /** @format int64 */
  id?: number;
  name?: string;
  description?: string;
  languages?: Language[];
  gender?: string;
  cloned?: boolean;
}

export interface UserResetPasswordRequest {
  code: string;
  password: string;
  confirmPassword?: string;
}

export interface EmptySuccessResponse {
  message?: string;
}

export interface UserProfileUpdateRequest {
  /** @format int64 */
  avatarId?: number;
  nickname: string;
  description?: string;
}

export interface IDOnlyResponse {
  /** @format int64 */
  id?: number;
}

export interface AgentThreadUpdateDto {
  title?: string;
  imageUrl?: string;
}

export interface AgentThreadVo {
  id?: string;
  autoMode?: boolean;
  title?: string;
  imageUrl?: string;
  /**
   * 分享类型: 0=PRIVATE(私有), 1=SHARED(共享), 2=FEATURESHARED(社区精选)
   * @format int32
   */
  shareType?: number;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
  status?: AgentThreadVoStatus;
  owner?: boolean;
}

export interface ApplyArtifactFileVersionRequest {
  /** @format int32 */
  index?: number;
  artifact_type?: ApplyArtifactFileVersionRequestArtifactType;
  file_type?: ApplyArtifactFileVersionRequestFileType;
  file_path?: string;
}

export interface TaskUpdateStatusRequest {
  status: TaskUpdateStatusRequestStatus;
}

export interface UpdateProjectRequest {
  title?: string;
  /** @format int64 */
  poster_asset_id?: number;
}

export interface ObjectVO {
  /** @format int64 */
  id?: number;
  type?: string;
  data?: string;
  /** @format int64 */
  userId?: number;
  deleted?: boolean;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface ObjectDTO {
  /** @format int64 */
  id?: number;
  type?: string;
  data?: string;
  /** @format int64 */
  userId?: number;
  deleted?: boolean;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface UserEmailVerifyRequest {
  verificationCode: string;
}

export interface UserProfile {
  /** @format int64 */
  id?: number;
  email?: string;
  nickname?: string;
  description?: string;
  emailVerified?: boolean;
  avatarUrl?: string;
}

export interface UserEmailSignupRequest {
  email: string;
  displayName: string;
  password: string;
  confirmPassword?: string;
  captchaVerifyParam?: string;
}

export interface SendResetPasswordEmailRequest {
  email: string;
}

export interface UserEmailSignInRequest {
  email: string;
  password: string;
  captchaVerifyParam?: string;
}

export interface AgentToolCallRequest {
  init_args?: Record<string, object>;
  call_args?: Record<string, object>;
  /** @format int32 */
  num_results?: number;
}

export interface ThreadReactiveVO {
  id?: string;
  userInput?: string;
  type?: string;
  audioScript?: string;
  requestId?: string;
  userId?: string;
  context?: Record<string, object>;
  templateId?: string;
  templateContent?: string;
  status?: string;
  projectId?: string;
  workingDir?: string;
  workflowCode?: string;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
  files?: UploadedFile[];
}

export interface UploadedFile {
  filename?: string;
  media_type?: string;
  /** @format int64 */
  size?: number;
  file_path?: string;
}

export interface AgentThreadMessageQueueResponse {
  status?: string;
}

export interface AgentThreadControlSignalDto {
  signal?: AgentThreadControlSignalDtoSignal;
}

export interface AgentThreadAutoModeDto {
  autoMode?: boolean;
}

export interface UploadArtifactFileResponse {
  file_path?: string;
  identity?: string;
}

export interface CropArea {
  /** @format int32 */
  x?: number;
  /** @format int32 */
  y?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface TaskCreateRequest {
  prompt?: string;
  /**
   * @format int64
   * @min 3
   */
  duration: number;
  model?: string;
  /** @format int64 */
  sourceVideoId?: number;
  /** @format int64 */
  sourceVideoStartTimestamp?: number;
  /** @format int64 */
  sourceVideoEndTimestamp?: number;
  enablePromptEnhancement?: boolean;
  enableAutoGenFirstFrame?: boolean;
  /** @format int64 */
  sourceImageId?: number;
  aspectRatio?: string;
  /** @format int64 */
  seed?: number;
  tSchedulerFunc?: string;
  tSchedulerArgs?: string;
  cropArea?: CropArea;
  extraInferArgs?: TaskExtraInferArgs;
}

export interface TaskExtraInferArgs {
  specialTokens?: string[];
  vaeModel?: string;
  resolution?: string;
  enhancementType?: string;
  extra?: string;
  modelVersion?: string;
  dryRun?: boolean;
  enableWatermark?: boolean;
  enableInputVideoToTs?: boolean;
  /** @format int32 */
  nSampleSteps?: number;
}

export interface TaskView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userId?: number;
  /** @format int64 */
  duration?: number;
  /** @format int64 */
  totalDuration?: number;
  /** @format int64 */
  sourceVideoId?: number;
  /** @format int64 */
  sourceImageId?: number;
  /** @format int64 */
  resultVideoId?: number;
  /** @format int64 */
  sourceVideoStartTimestamp?: number;
  /** @format int64 */
  sourceVideoEndTimestamp?: number;
  /** @format int64 */
  seed?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format int32 */
  expectedChunkCount?: number;
  /** @format int32 */
  completedChunkCount?: number;
  enablePromptEnhancement?: boolean;
  enableAutoGenFirstFrame?: boolean;
  isFavorite?: boolean;
  isPublic?: boolean;
  prompt?: string;
  model?: string;
  aspectRatio?: string;
  underlyingModel?: string;
  resultVideoUrl?: string;
  resultVideoPosterUrl?: string;
  sourceVideoUrl?: string;
  sourceVideoPosterUrl?: string;
  sourceImageUrl?: string;
  enhancedPrompt?: string;
  status?: TaskViewStatus;
  type?: TaskViewType;
  cropArea?: CropArea;
  /** @format date-time */
  createTime?: string;
  firstFramePrompt?: string;
  tSchedulerFunc?: string;
  tSchedulerArgs?: string;
  extraInferArgs?: TaskExtraInferArgs;
  tschedulerFunc?: string;
  tschedulerArgs?: string;
  favorite?: boolean;
  public?: boolean;
}

export interface GenerationChunksRequestVO {
  /** @format int64 */
  generationId?: number;
  chunkIds?: number[];
}

export interface ShareGenerationsRequest {
  chunks?: GenerationChunksRequestVO[];
  /** @format int64 */
  assetId?: number;
}

export interface ShareVO {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  taskId?: number;
  content?: ShareGenerationsRequest;
  posterUrl?: string;
}

export interface Share {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  taskId?: number;
  /** @format int64 */
  userId?: number;
  content?: string;
  contentHash?: string;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
  staffPick?: boolean;
}

export interface ReportCreateRequest {
  /** @format int64 */
  targetId: number;
  targetType: string;
  tags: string[];
  comment?: string;
}

export interface PromptSuggestionRequest {
  /** @format int64 */
  assetId?: number;
  prompt?: string;
  suggestionType?: string;
  /** @format int32 */
  cnt?: number;
  enableEnhancement?: boolean;
  enhancementType?: string;
  cropArea?: CropArea;
}

export interface PromptSuggestion {
  prompt?: string;
  enhancedPrompt?: string;
}

export interface PromptEnhancementRequest {
  prompt?: string;
  /** @format int64 */
  assetId?: number;
  enhancementType?: string;
}

export interface PromptEnhancementResponse {
  generatedPrompt?: string;
  generatedImagePrompt?: string;
}

export interface RunCoziWorkflowRequest {
  parameters?: object;
  workflowId?: string;
  applicationId?: string;
}

export interface JSONObject {
  innerMap?: Record<string, object>;
  empty?: boolean;
  [key: string]: any;
}

export interface CreateProjectRequest {
  canvasJson?: string;
  title?: string;
  /** @format int64 */
  posterAssetId?: number;
}

export interface CustomApiPackageRequestVo {
  company?: string;
  business?: string;
  phone?: string;
  detail: string;
}

export interface ApiKeyRequest {
  name: string;
}

export interface ApiKey {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userId?: number;
  /** @format int64 */
  orgId?: number;
  name?: string;
  value?: string;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface SubscribeRequest {
  type: SubscribeRequestType;
  data: string;
}

export interface SubscriptionView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userId?: number;
  type?: SubscriptionViewType;
  data?: string;
}

export interface ConditionVO {
  type?: string;
  content?: string;
}

export interface LiveGenerateRequest {
  /** @format int64 */
  streamId?: number;
  steps?: Step[];
  source?: ConditionVO;
  model?: string;
  enablePromptEnhancement?: boolean;
  enableAutoGenFirstFrame?: boolean;
  aspectRatio?: string;
  /** @format int64 */
  seed?: number;
  tSchedulerFunc?: string;
  tSchedulerArgs?: string;
  cropArea?: CropArea;
  extraInferArgs?: TaskExtraInferArgs;
  tschedulerFunc?: string;
  tschedulerArgs?: string;
}

export interface Step {
  prompt?: string;
  /** @format float */
  duration?: number;
}

export interface LiveGenerateResponse {
  /** @format int64 */
  streamId?: number;
  status?: LiveGenerateResponseStatus;
  /** @format date-time */
  nextAvailableTime?: string;
  submitted?: boolean;
  /** @format date-time */
  streamEndTime?: string;
  /** @format date-time */
  streamStartTime?: string;
  taskIds?: number[];
}

export interface VerifyPermissionRequest {
  function?: VerifyPermissionRequestFunction;
}

export interface InvitationCodeResponse {
  success?: boolean;
  message?: string;
  invitationCodes?: Record<string, string[]>;
}

export interface UseInvitationCodeRequest {
  code?: string;
}

export interface UnbindInvitationCodeRequest {
  /** @format int64 */
  userId?: number;
  invitationCode?: string;
}

export interface GenerateInvitationCodeRequest {
  codeIdentifier?: string;
  functions?: GenerateInvitationCodeRequestFunctions[];
  /** @format int32 */
  maxUsageCount?: number;
  /** @format int32 */
  codeCount?: number;
  description?: string;
  /** @format int64 */
  effectiveTime?: number;
  /** @format int64 */
  expireTime?: number;
}

export interface InferEvent {
  notification_type?: string;
  /** @format int64 */
  notification_id?: number;
  payload?: JsonNode;
  timestamp?: string;
}

export type JsonNode = object;

export interface ChunkVO {
  /** @format float */
  duration?: number;
  conditions?: ConditionVO[];
}

export interface CreateImageRequest {
  model?: string;
  prompt?: string;
  images?: number[];
  chunks?: ChunkVO[];
  aspectRatio?: string;
  taskSource?: CreateImageRequestTaskSource;
  enableEnhancePrompt?: boolean;
  enhancementType?: string;
}

export interface CreateImageDTO {
  /** @format int64 */
  id?: number;
}

export interface ListImageRequest {
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
  taskSources?: ListImageRequestTaskSources[];
  taskTypes?: ListImageRequestTaskTypes[];
  taskStatuses?: ListImageRequestTaskStatuses[];
  /** @format int64 */
  startCreateTime?: number;
  /** @format int64 */
  endCreateTime?: number;
}

export interface ImageDTO {
  /** @format int64 */
  id?: number;
  status?: string;
  /** @format int64 */
  resultImageId?: number;
  sourceAssets?: number[];
  prompt?: string;
}

export interface ListResponseByPageImageDTO {
  list?: ImageDTO[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface ExtraArgs {
  enablePromptEnhancement?: boolean;
  cropArea?: CropArea;
  extraInferArgs?: TaskExtraInferArgs;
  tSchedulerFunc?: string;
  tSchedulerArgs?: string;
}

export interface GenerationRequestVO {
  model?: string;
  /** @format int64 */
  seed?: number;
  aspectRatio?: string;
  source?: ConditionVO;
  chunks: ChunkVO[];
  extraArgs: ExtraArgs;
  taskSource?: GenerationRequestVoTaskSource;
  taskType?: GenerationRequestVoTaskType;
}

export interface GenerationResponseVO {
  /** @format int64 */
  id?: number;
}

export interface PipelineRequestVO {
  tasks: GenerationRequestVO[];
}

export interface PipelineResponseVO {
  /** @format int64 */
  pipelineId?: number;
  taskIds?: number[];
}

export interface ListGenerationRequest {
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
  taskSources?: ListGenerationRequestTaskSources[];
  taskTypes?: ListGenerationRequestTaskTypes[];
  taskStatuses?: ListGenerationRequestTaskStatuses[];
  /** @format int64 */
  startCreateTime?: number;
  /** @format int64 */
  endCreateTime?: number;
}

export interface Chunk {
  /** @format float */
  duration?: number;
  status?: string;
  /** @format int64 */
  id?: number;
  conditions?: ConditionVO[];
  prompt?: string;
  enhancedPrompt?: string;
}

export interface GenerationVO {
  /** @format int64 */
  id?: number;
  status?: string;
  /** @format int32 */
  progress?: number;
  chunks?: Chunk[];
  result?: ResultVO;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  estimateCompleteTime?: string;
  /** @format date-time */
  estimateStartTime?: string;
  moderationPassed?: boolean;
}

export interface ListResponseByPageGenerationVO {
  list?: GenerationVO[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface ResultVO {
  videoURL?: string;
  posterURL?: string;
  videoModerationStatus?: ResultVoVideoModerationStatus;
  /** @format int64 */
  videoId?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format float */
  duration?: number;
  /** @format int64 */
  imageId?: number;
}

export interface ImageGenerationRequestVO {
  prompt?: string;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  w?: number;
  /** @format int32 */
  h?: number;
}

export interface ImageGenerationResponseVO {
  /** @format int64 */
  id?: number;
  url?: string;
}

export interface AddFavoriteRequest {
  /** @format int64 */
  taskId: number;
}

export interface SetConfigRequest {
  key?: string;
  value?: string;
  configServiceEnum?: SetConfigRequestConfigServiceEnum;
}

export interface ConfigItem {
  key?: string;
  value?: string;
}

export interface ConfigResponse {
  success?: boolean;
  values?: ConfigItem[];
}

export interface GetConfigRequest {
  keys?: string[];
  configServiceEnum?: GetConfigRequestConfigServiceEnum;
}

export interface CheckAuthVo {
  result?: boolean;
}

export interface AssetView {
  /** @format int64 */
  id?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format float */
  duration?: number;
  url?: string;
  previewUrl?: string;
  mediaType?: AssetViewMediaType;
  source?: AssetViewSource;
  /** @format int64 */
  generationId?: number;
  generation?: GenerationDetailResponseVO;
  filename?: string;
  favorite?: boolean;
  /** @format int64 */
  voiceId?: number;
}

export interface GenerationDetailResponseVO {
  /** @format int64 */
  id?: number;
  model?: string;
  status?: string;
  /** @format int32 */
  progress?: number;
  chunks?: Chunk[];
  resultVideoURL?: string;
  resultPosterURL?: string;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format float */
  duration?: number;
  resultVideoModerationStatus?: GenerationDetailResponseVoResultVideoModerationStatus;
  /** @format int64 */
  resultVideoId?: number;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  estimateCompleteTime?: string;
  /** @format date-time */
  estimateStartTime?: string;
  source?: ConditionVO;
  extraArgs?: ExtraArgs;
  moderationPassed?: boolean;
}

export interface ModerateVideoCallbackRequest {
  checksum?: string;
  content?: string;
}

export interface TextToSpeechRequest {
  /** @format int64 */
  voiceId?: number;
  text?: string;
}

export interface MultipartUploadInitRequest {
  fileName?: string;
  contentType?: string;
  /** @format int64 */
  fileSize?: number;
}

export interface MultipartUploadVO {
  uploadId?: string;
  objectKey?: string;
  /** @format int32 */
  partCount?: number;
  signedUrls?: string[];
  downloadUrl?: string;
}

export interface MultipartUploadCompleteRequest {
  uploadId?: string;
  objectKey?: string;
  parts?: MultipartUploadPart[];
}

export interface MultipartUploadPart {
  /** @format int32 */
  part_number?: number;
  etag?: string;
}

export interface AgentEventRequest {
  name: AgentEventRequestName;
  payload: Record<string, object>;
  thread_id: string;
}

export interface AdminBanUserRequest {
  email: string;
}

export interface GeneralResponse {
  success?: boolean;
  message?: string;
  data?: object;
}

export interface GrantMembershipRequest {
  /** @format int64 */
  userId: number;
  /** @pattern ^(plus|pro|premium)_plan_(monthly|yearly)$ */
  planCode: string;
}

export interface GrantMembershipResultResponse {
  success?: boolean;
  message?: string;
  /** @format int64 */
  orderId?: number;
  /** @format int64 */
  userId?: number;
  planCode?: string;
  currentPlanCode?: string;
  currentPlanExpireTime?: string;
  grantTime?: string;
}

export interface TempUserInfo {
  email?: string;
  password?: string;
}

export interface ListResponseVoiceView {
  data?: VoiceView[];
}

export interface ListResponseByPageAgentThreadVo {
  list?: AgentThreadVo[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface ToolInfoDto {
  type?: string;
  options?: Record<string, object>;
  init_args?: Record<string, object>;
  call_args?: Record<string, object>;
  /** @format int32 */
  num_results?: number;
}

export interface AgentThreadTask {
  id?: string;
  task_type?: string;
  thread_id?: string;
  data?: Record<string, object>;
  status?: AgentThreadTaskStatus;
  message?: string;
  /** @format date-time */
  create_time?: string;
  /** @format date-time */
  update_time?: string;
}

export interface AgentThreadShareVo {
  id?: string;
  title?: string;
  imageUrl?: string;
  /**
   * 分享类型: 0=PRIVATE(私有), 1=SHARED(共享), 2=FEATURESHARED(社区精选)
   * @format int32
   */
  shareType?: number;
  prompt?: string;
  files?: UploadFile[];
  resultPath?: string;
  owner?: boolean;
}

export interface UploadFile {
  filename?: string;
  mediaType?: string;
  /** @format int32 */
  size?: number;
  filePath?: string;
}

export interface AgentThreadMessageDetail {
  id?: string;
  threadId?: string;
  type?: AgentThreadMessageDetailType;
  content?: Record<string, object>;
  status?: AgentThreadMessageDetailStatus;
  /** @format double */
  timestamp?: number;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface ListResponseByPageAgentThreadMessageDetail {
  list?: AgentThreadMessageDetail[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface ListResponseByPageTaskView {
  list?: TaskView[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface TaskResultView {
  downloadUrl?: string;
}

export interface TaskDebugInfoVO {
  task?: {
    innerMap?: Record<string, object>;
    empty?: boolean;
    [key: string]: any;
  };
}

export interface SystemConfigView {
  disableEmailLogin?: boolean;
}

export interface ReasonCategoryVo {
  name?: string;
  tags?: TagVo[];
}

export interface ReportTagsVo {
  categories?: ReasonCategoryVo[];
}

export interface TagVo {
  code?: string;
  description?: string;
}

export interface ListResponseByPageProjectView {
  list?: ProjectView[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface ProjectView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userId?: number;
  canvasJson?: string;
  title?: string;
  posterUrl?: string;
  /** @format int64 */
  posterAssetId?: number;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface ListResponseByPagePlatformOrderVo {
  list?: PlatformOrderVo[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface PlatformOrderVo {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  amount?: number;
  payer?: UserProfile;
  /** @format int64 */
  creditAmount?: number;
  /** @format date-time */
  createTime?: string;
}

export interface CreditDetailVo {
  creditAmount?: string;
  creditType?: string;
  expireTime?: string;
}

export interface PlatformOrganizationCreditVo {
  creditAmount?: string;
  creditDetailList?: CreditDetailVo[];
  usage?: UserCreditDailyUsageDO[];
}

export interface UserCreditDailyUsageDO {
  /** @format int32 */
  amount?: number;
  date?: string;
}

export interface ListResponseByPageUserCreditTransactionVo {
  list?: UserCreditTransactionVo[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface UserCreditTransactionVo {
  /** @format int32 */
  amount?: number;
  createTime?: string;
  direction?: string;
  reasonType?: string;
  reasonSubType?: string;
}

export interface PlatformCreditPackage {
  id?: string;
  price?: string;
  /** @format int32 */
  amount?: number;
  outCode?: string;
  currency?: string;
  status?: PlatformCreditPackageStatus;
}

export interface ApiKeyVo {
  /** @format int64 */
  id?: number;
  name?: string;
  /** @format date-time */
  createTime?: string;
}

export interface FeatureVO {
  description?: string;
  tooltip?: string;
}

export interface PlanPageVo {
  planList?: PlanVo[];
  yearlyDiscount?: string;
  /** @format int32 */
  freeCreditAmount?: number;
}

export interface PlanVo {
  price?: string;
  originalPrice?: string;
  planCode?: string;
  currency?: string;
  priceId?: string;
  intervalType?: string;
  memberShipName?: string;
  description?: string;
  tooltipForCredit?: string;
  /** @format int32 */
  planGrade?: number;
  /** @format int32 */
  creditAmount?: number;
  featureList?: FeatureVO[];
  recommend?: boolean;
}

export interface UserPlanVo {
  planCode?: string;
  price?: string;
  originalPrice?: string;
  currency?: string;
  memberShipName?: string;
  intervalType?: string;
  creditAmount?: string;
  expireTime?: string;
  status?: string;
}

export interface VapidPublicKeyView {
  publicKey?: string;
}

export interface LiveStatusResponse {
  status?: LiveStatusResponseStatus;
  /** @format int64 */
  streamId?: number;
  /** @format date-time */
  nextAvailableTime?: string;
  /** @format date-time */
  streamEndTime?: string;
  /** @format date-time */
  streamStartTime?: string;
  taskIds?: number[];
}

export type StreamingResponseBody = object;

export interface PipelineDetailResponseVO {
  /** @format int64 */
  pipelineId?: number;
  status?: string;
  taskIds?: number[];
}

export interface ListResponseByPageAssetView {
  list?: AssetView[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface UserCreditVo {
  creditAmount?: string;
  creditDetailList?: CreditDetailVo[];
}

export interface UserCreditTransactionPageVo {
  list?: UserCreditTransactionVo[];
  nextContinuationToken?: string;
}

export interface CreditPackagePageVo {
  creditPackageList?: CreditPackageVo[];
}

export interface CreditPackageVo {
  amount?: string;
  price?: string;
  priceId?: string;
  description?: string;
}

export interface AuthVo {
  codes?: string[];
}

export interface UserPlanInfoResponse {
  /** @format int64 */
  userId?: number;
  email?: string;
  nickname?: string;
  currentPlanCode?: string;
  currentPlanName?: string;
  expireTime?: string;
  nextRenewTime?: string;
  hasActivePlan?: boolean;
}

export enum AgentThreadVoStatus {
  WorkflowGenerated = "workflow_generated",
  Pending = "pending",
  Running = "running",
  Success = "success",
  Terminated = "terminated",
  Failed = "failed",
  Waiting = "waiting",
  Stopping = "stopping",
}

export enum ApplyArtifactFileVersionRequestArtifactType {
  ValueVideoAnalysisResultArtifact = "<Video Analysis Result Artifact>",
  ValueAudioAnalysisResultArtifact = "<Audio Analysis Result Artifact>",
  ValueScriptArtifact = "<Script Artifact>",
  ValueCreativeSummaryArtifact = "<Creative Summary Artifact>",
  ValueShotsArtifact = "<Shots Artifact>",
  ValueOriginalSubtitlesArtifact = "<Original Subtitles Artifact>",
  ValueAdjustedSubtitlesArtifact = "<Adjusted Subtitles Artifact>",
  ValueSpeechArtifact = "<Speech Artifact>",
  ValueMusicClipsArtifact = "<Music Clips Artifact>",
  ValueOTIOTimelineArtifact = "<OTIO Timeline Artifact>",
  ValueFinalResultArtifact = "<Final Result Artifact>",
  ValueSelectedVoiceArtifact = "<Selected Voice Artifact>",
  ValueLineSubtitlesArtifact = "<Line Subtitles Artifact>",
  ValueReferenceImageArtifact = "<Reference Image Artifact>",
  ValueCharacterVoiceArtifact = "<Character Voice Artifact>",
}

export enum ApplyArtifactFileVersionRequestFileType {
  StartFrameImage = "start_frame_image",
  VideoClip = "video_clip",
  MusicClip = "music_clip",
  ReferenceImage = "reference_image",
}

export enum TaskUpdateStatusRequestStatus {
  PreProcessing = "PreProcessing",
  Pending = "Pending",
  Running = "Running",
  Success = "Success",
  Fail = "Fail",
  Canceled = "Canceled",
}

export enum AgentThreadControlSignalDtoSignal {
  ValueCtrlTerminate = "<ctrl:terminate>",
  ValueCtrlStop = "<ctrl:stop>",
  ValueCtrlStopImmediately = "<ctrl:stop-immediately>",
  ValueCtrlCancel = "<ctrl:cancel>",
  ValueCtrlContinue = "<ctrl:continue>",
  ValueCtrlAutoModeEnable = "<ctrl:auto-mode=enable>",
  ValueCtrlAutoModeDisable = "<ctrl:auto-mode=disable>",
}

export enum TaskViewStatus {
  PreProcessing = "PreProcessing",
  Pending = "Pending",
  Running = "Running",
  Success = "Success",
  Fail = "Fail",
  Canceled = "Canceled",
}

export enum TaskViewType {
  ExtendDuration = "ExtendDuration",
  I2V = "I2V",
  T2V = "T2V",
  A2V = "A2V",
  IT2I = "IT2I",
  I2FV = "I2FV",
}

export enum SubscribeRequestType {
  WEB_PUSH = "WEB_PUSH",
}

export enum SubscriptionViewType {
  WEB_PUSH = "WEB_PUSH",
}

export enum LiveGenerateResponseStatus {
  AVAILABLE = "AVAILABLE",
  STOPPED = "STOPPED",
  NO_RESOURCES = "NO_RESOURCES",
  PROCESSING = "PROCESSING",
}

export enum VerifyPermissionRequestFunction {
  VID_MUSE = "VID_MUSE",
}

export enum GenerateInvitationCodeRequestFunctions {
  VID_MUSE = "VID_MUSE",
}

export enum CreateImageRequestTaskSource {
  NORMAL = "NORMAL",
  INSPIRATION = "INSPIRATION",
  FLEXIBLE = "FLEXIBLE",
  LIVE = "LIVE",
  PROJECT = "PROJECT",
  API_PLATFORM = "API_PLATFORM",
  HUMAN = "HUMAN",
  GAGA_IMAGE = "GAGA_IMAGE",
  PERFORMER_IMAGE = "PERFORMER_IMAGE",
  HUMAN_API_PLATFORM = "HUMAN_API_PLATFORM",
}

export enum ListImageRequestTaskSources {
  NORMAL = "NORMAL",
  INSPIRATION = "INSPIRATION",
  FLEXIBLE = "FLEXIBLE",
  LIVE = "LIVE",
  PROJECT = "PROJECT",
  API_PLATFORM = "API_PLATFORM",
  HUMAN = "HUMAN",
  GAGA_IMAGE = "GAGA_IMAGE",
  PERFORMER_IMAGE = "PERFORMER_IMAGE",
  HUMAN_API_PLATFORM = "HUMAN_API_PLATFORM",
}

export enum ListImageRequestTaskTypes {
  ExtendDuration = "ExtendDuration",
  I2V = "I2V",
  T2V = "T2V",
  A2V = "A2V",
  IT2I = "IT2I",
  I2FV = "I2FV",
}

export enum ListImageRequestTaskStatuses {
  PreProcessing = "PreProcessing",
  Pending = "Pending",
  Running = "Running",
  Success = "Success",
  Fail = "Fail",
  Canceled = "Canceled",
}

export enum GenerationRequestVoTaskSource {
  NORMAL = "NORMAL",
  INSPIRATION = "INSPIRATION",
  FLEXIBLE = "FLEXIBLE",
  LIVE = "LIVE",
  PROJECT = "PROJECT",
  API_PLATFORM = "API_PLATFORM",
  HUMAN = "HUMAN",
  GAGA_IMAGE = "GAGA_IMAGE",
  PERFORMER_IMAGE = "PERFORMER_IMAGE",
  HUMAN_API_PLATFORM = "HUMAN_API_PLATFORM",
}

export enum GenerationRequestVoTaskType {
  ExtendDuration = "ExtendDuration",
  I2V = "I2V",
  T2V = "T2V",
  A2V = "A2V",
  IT2I = "IT2I",
  I2FV = "I2FV",
}

export enum ListGenerationRequestTaskSources {
  NORMAL = "NORMAL",
  INSPIRATION = "INSPIRATION",
  FLEXIBLE = "FLEXIBLE",
  LIVE = "LIVE",
  PROJECT = "PROJECT",
  API_PLATFORM = "API_PLATFORM",
  HUMAN = "HUMAN",
  GAGA_IMAGE = "GAGA_IMAGE",
  PERFORMER_IMAGE = "PERFORMER_IMAGE",
  HUMAN_API_PLATFORM = "HUMAN_API_PLATFORM",
}

export enum ListGenerationRequestTaskTypes {
  ExtendDuration = "ExtendDuration",
  I2V = "I2V",
  T2V = "T2V",
  A2V = "A2V",
  IT2I = "IT2I",
  I2FV = "I2FV",
}

export enum ListGenerationRequestTaskStatuses {
  PreProcessing = "PreProcessing",
  Pending = "Pending",
  Running = "Running",
  Success = "Success",
  Fail = "Fail",
  Canceled = "Canceled",
}

export enum ResultVoVideoModerationStatus {
  Running = "Running",
  Completed = "Completed",
}

export enum SetConfigRequestConfigServiceEnum {
  REDIS_CONFIG = "REDIS_CONFIG",
}

export enum GetConfigRequestConfigServiceEnum {
  REDIS_CONFIG = "REDIS_CONFIG",
}

export enum AssetViewMediaType {
  JPEG = "JPEG",
  PNG = "PNG",
  WEBP = "WEBP",
  MP4 = "MP4",
  TransportStream = "TransportStream",
  FLV = "FLV",
  QuickTime = "QuickTime",
  MPEG = "MPEG",
  WEBM_VIDEO = "WEBM_VIDEO",
  WMV = "WMV",
  THREE_GPP = "THREE_GPP",
  WAV = "WAV",
  AAC = "AAC",
  FLAC = "FLAC",
  MP3 = "MP3",
  M4A = "M4A",
  OPUS = "OPUS",
  PCM = "PCM",
  WEBM_AUDIO = "WEBM_AUDIO",
}

export enum AssetViewSource {
  Upload = "Upload",
  Generate = "Generate",
  GenerateFirstFrame = "GenerateFirstFrame",
  ExtractVideoPoster = "ExtractVideoPoster",
  Crop = "Crop",
  AvatarDownload = "AvatarDownload",
  AvatarUpload = "AvatarUpload",
  InspirationFirstFrameCandidate = "InspirationFirstFrameCandidate",
  Featured = "Featured",
  HumanFeatured = "HumanFeatured",
  SourceVideoToTs = "SourceVideoToTs",
  VoicePreview = "VoicePreview",
  TextToSpeech = "TextToSpeech",
  CreateImage = "CreateImage",
}

export enum GenerationDetailResponseVoResultVideoModerationStatus {
  Running = "Running",
  Completed = "Completed",
}

export enum AgentEventRequestName {
  STATUS_CHANGE = "STATUS_CHANGE",
}

export enum AgentThreadTaskStatus {
  Pending = "pending",
  Running = "running",
  Success = "success",
  Failed = "failed",
}

export enum AgentThreadMessageDetailType {
  User = "user",
  Assistant = "assistant",
  Tool = "tool",
  System = "system",
  Developer = "developer",
  Function = "function",
}

export enum AgentThreadMessageDetailStatus {
  Done = "done",
  Appending = "appending",
  Waiting = "waiting",
}

export enum PlatformCreditPackageStatus {
  ACTIVE = "ACTIVE",
  DEPRECATED = "DEPRECATED",
  OFFLINE = "OFFLINE",
}

export enum LiveStatusResponseStatus {
  AVAILABLE = "AVAILABLE",
  STOPPED = "STOPPED",
  NO_RESOURCES = "NO_RESOURCES",
  PROCESSING = "PROCESSING",
}

export enum UploadArtifactFileParamsArtifactType {
  ValueVideoAnalysisResultArtifact = "<Video Analysis Result Artifact>",
  ValueAudioAnalysisResultArtifact = "<Audio Analysis Result Artifact>",
  ValueScriptArtifact = "<Script Artifact>",
  ValueCreativeSummaryArtifact = "<Creative Summary Artifact>",
  ValueShotsArtifact = "<Shots Artifact>",
  ValueOriginalSubtitlesArtifact = "<Original Subtitles Artifact>",
  ValueAdjustedSubtitlesArtifact = "<Adjusted Subtitles Artifact>",
  ValueSpeechArtifact = "<Speech Artifact>",
  ValueMusicClipsArtifact = "<Music Clips Artifact>",
  ValueOTIOTimelineArtifact = "<OTIO Timeline Artifact>",
  ValueFinalResultArtifact = "<Final Result Artifact>",
  ValueSelectedVoiceArtifact = "<Selected Voice Artifact>",
  ValueLineSubtitlesArtifact = "<Line Subtitles Artifact>",
  ValueReferenceImageArtifact = "<Reference Image Artifact>",
  ValueCharacterVoiceArtifact = "<Character Voice Artifact>",
}

export enum GetTasksParamsTaskSource {
  NORMAL = "NORMAL",
  INSPIRATION = "INSPIRATION",
  FLEXIBLE = "FLEXIBLE",
  LIVE = "LIVE",
  PROJECT = "PROJECT",
  API_PLATFORM = "API_PLATFORM",
  HUMAN = "HUMAN",
  GAGA_IMAGE = "GAGA_IMAGE",
  PERFORMER_IMAGE = "PERFORMER_IMAGE",
  HUMAN_API_PLATFORM = "HUMAN_API_PLATFORM",
}

export enum ListGenerationsParamsTaskSources {
  NORMAL = "NORMAL",
  INSPIRATION = "INSPIRATION",
  FLEXIBLE = "FLEXIBLE",
  LIVE = "LIVE",
  PROJECT = "PROJECT",
  API_PLATFORM = "API_PLATFORM",
  HUMAN = "HUMAN",
  GAGA_IMAGE = "GAGA_IMAGE",
  PERFORMER_IMAGE = "PERFORMER_IMAGE",
  HUMAN_API_PLATFORM = "HUMAN_API_PLATFORM",
}

export enum ListGenerationsParamsTaskTypes {
  ExtendDuration = "ExtendDuration",
  I2V = "I2V",
  T2V = "T2V",
  A2V = "A2V",
  IT2I = "IT2I",
  I2FV = "I2FV",
}

export enum ListAssetsParamsSources {
  Upload = "Upload",
  Generate = "Generate",
  Featured = "Featured",
  HumanFeatured = "HumanFeatured",
  TextToSpeech = "TextToSpeech",
  CreateImage = "CreateImage",
}

export enum ListAssetsParamsTypes {
  Video = "Video",
  Image = "Image",
  Audio = "Audio",
}

/** @default "Upload" */
export enum UploadAssetParamsSource {
  Upload = "Upload",
  Generate = "Generate",
  GenerateFirstFrame = "GenerateFirstFrame",
  ExtractVideoPoster = "ExtractVideoPoster",
  Crop = "Crop",
  AvatarDownload = "AvatarDownload",
  AvatarUpload = "AvatarUpload",
  InspirationFirstFrameCandidate = "InspirationFirstFrameCandidate",
  Featured = "Featured",
  HumanFeatured = "HumanFeatured",
  SourceVideoToTs = "SourceVideoToTs",
  VoicePreview = "VoicePreview",
  TextToSpeech = "TextToSpeech",
  CreateImage = "CreateImage",
}

export enum GetFavoriteAssetsParamsTypes {
  Video = "Video",
  Image = "Image",
  Audio = "Audio",
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "https://vidmuse-dev.sandaii.cn",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl https://vidmuse-dev.sandaii.cn
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags home-controller
   * @name Home
   * @request GET:/
   * @response `200` `string` OK
   */
  home = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/`,
      method: "GET",
      ...params,
    });

  voices = {
    /**
     * No description
     *
     * @tags voice-controller
     * @name UpdateVoice
     * @request PUT:/api/v1/voices/{voiceId}
     * @response `200` `VoiceView` OK
     */
    updateVoice: (
      voiceId: number,
      data: UpdateVoiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<VoiceView, any>({
        path: `/api/v1/voices/${voiceId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags voice-controller
     * @name DeleteVoice
     * @request DELETE:/api/v1/voices/{voiceId}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteVoice: (voiceId: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/voices/${voiceId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags voice-controller
     * @name GetVoices
     * @request GET:/api/v1/voices
     * @response `200` `ListResponseVoiceView` OK
     */
    getVoices: (params: RequestParams = {}) =>
      this.request<ListResponseVoiceView, any>({
        path: `/api/v1/voices`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags voice-controller
     * @name CreateVoice
     * @request POST:/api/v1/voices
     * @response `200` `VoiceView` OK
     */
    createVoice: (
      query: {
        name: string;
        description: string;
      },
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<VoiceView, any>({
        path: `/api/v1/voices`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags voice-controller
     * @name SyncProviderVoices
     * @request POST:/api/v1/voices/sync-provider-voices
     * @response `200` `Record<string,object>` OK
     */
    syncProviderVoices: (
      query?: {
        /** @default false */
        updateExisting?: boolean;
        /** @default "minimax" */
        provider?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/voices/sync-provider-voices`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags voice-controller
     * @name DetectLanguage
     * @request POST:/api/v1/voices/detect-language
     * @response `200` `Record<string,object>` OK
     */
    detectLanguage: (
      query: {
        text: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/voices/detect-language`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags voice-controller
     * @name UpdateVoiceGender
     * @request PATCH:/api/v1/voices/{voiceId}/gender
     * @response `200` `VoiceView` OK
     */
    updateVoiceGender: (
      voiceId: number,
      query: {
        /** @pattern ^(male|female)$ */
        gender: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VoiceView, any>({
        path: `/api/v1/voices/${voiceId}/gender`,
        method: "PATCH",
        query: query,
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags signup-controller
     * @name ResetPassword
     * @request PUT:/api/v1/user/reset-password
     * @response `200` `EmptySuccessResponse` OK
     */
    resetPassword: (
      data: UserResetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/user/reset-password`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags profile-controller
     * @name CurrentUserProfile
     * @request GET:/api/v1/user/profile
     * @response `200` `UserProfile` OK
     */
    currentUserProfile: (params: RequestParams = {}) =>
      this.request<UserProfile, any>({
        path: `/api/v1/user/profile`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags profile-controller
     * @name UpdateUserProfile
     * @request PUT:/api/v1/user/profile
     * @response `200` `IDOnlyResponse` OK
     */
    updateUserProfile: (
      data: UserProfileUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/user/profile`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags signup-controller
     * @name VerifyEmail
     * @request POST:/api/v1/user/verify-email
     * @response `200` `UserProfile` OK
     */
    verifyEmail: (data: UserEmailVerifyRequest, params: RequestParams = {}) =>
      this.request<UserProfile, any>({
        path: `/api/v1/user/verify-email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags signup-controller
     * @name Signup
     * @request POST:/api/v1/user/signup
     * @response `200` `UserProfile` OK
     */
    signup: (data: UserEmailSignupRequest, params: RequestParams = {}) =>
      this.request<UserProfile, any>({
        path: `/api/v1/user/signup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags signup-controller
     * @name SendVerifyEmail
     * @request POST:/api/v1/user/send-verify-email
     * @response `200` `UserProfile` OK
     */
    sendVerifyEmail: (params: RequestParams = {}) =>
      this.request<UserProfile, any>({
        path: `/api/v1/user/send-verify-email`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags signup-controller
     * @name SendResetPasswordEmail
     * @request POST:/api/v1/user/send-reset-password-email
     * @response `200` `EmptySuccessResponse` OK
     */
    sendResetPasswordEmail: (
      data: SendResetPasswordEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/user/send-reset-password-email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags signup-controller
     * @name Login
     * @request POST:/api/v1/user/login
     * @response `200` `UserProfile` OK
     */
    login: (data: UserEmailSignInRequest, params: RequestParams = {}) =>
      this.request<UserProfile, any>({
        path: `/api/v1/user/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  threads = {
    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name GetThreadDetail
     * @request GET:/api/v1/threads/{threadId}
     * @response `200` `AgentThreadVo` OK
     */
    getThreadDetail: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name UpdateThread
     * @request PUT:/api/v1/threads/{threadId}
     * @response `200` `AgentThreadVo` OK
     */
    updateThread: (
      threadId: string,
      data: AgentThreadUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name DeleteThread
     * @request DELETE:/api/v1/threads/{threadId}
     * @response `200` `void` OK
     */
    deleteThread: (threadId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/threads/${threadId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ApplyArtifactFileVersion
     * @request PUT:/api/v1/threads/{threadId}/artifacts/file-version
     * @response `200` `Record<string,object>` OK
     */
    applyArtifactFileVersion: (
      threadId: string,
      data: ApplyArtifactFileVersionRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/threads/${threadId}/artifacts/file-version`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ListThreads
     * @request GET:/api/v1/threads
     * @response `200` `ListResponseByPageAgentThreadVo` OK
     */
    listThreads: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAgentThreadVo, any>({
        path: `/api/v1/threads`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name CreateThread
     * @request POST:/api/v1/threads
     * @response `200` `AgentThreadVo` OK
     */
    createThread: (
      query: {
        files: File[];
        file_urls?: string;
        user_input?: string;
        auto_mode?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name CallTool
     * @request POST:/api/v1/threads/{threadId}/tools/{toolType}
     * @response `200` `Record<string,object>` OK
     */
    callTool: (
      threadId: string,
      toolType: string,
      data: AgentToolCallRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/threads/${threadId}/tools/${toolType}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name GetSharedThread
     * @request GET:/api/v1/threads/{threadId}/share
     * @response `200` `AgentThreadShareVo` OK
     */
    getSharedThread: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadShareVo, any>({
        path: `/api/v1/threads/${threadId}/share`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ShareThread
     * @request POST:/api/v1/threads/{threadId}/share
     * @response `200` `AgentThreadVo` OK
     */
    shareThread: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}/share`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ReactiveThread
     * @request POST:/api/v1/threads/{threadId}/reactive
     * @response `200` `ThreadReactiveVO` OK
     */
    reactiveThread: (
      threadId: string,
      query: {
        auto_mode: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThreadReactiveVO, any>({
        path: `/api/v1/threads/${threadId}/reactive`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name NameThreadByAi
     * @request POST:/api/v1/threads/{threadId}/name-by-ai
     * @response `200` `AgentThreadVo` OK
     */
    nameThreadByAi: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}/name-by-ai`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-message-controller
     * @name ListMessages
     * @request GET:/api/v1/threads/{threadId}/messages
     * @response `200` `ListResponseByPageAgentThreadMessageDetail` OK
     */
    listMessages: (
      threadId: string,
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAgentThreadMessageDetail, any>({
        path: `/api/v1/threads/${threadId}/messages`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-message-controller
     * @name SendMessage
     * @request POST:/api/v1/threads/{threadId}/messages
     * @response `200` `AgentThreadMessageQueueResponse` OK
     */
    sendMessage: (
      threadId: string,
      query: {
        files: File[];
        text?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadMessageQueueResponse, any>({
        path: `/api/v1/threads/${threadId}/messages`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ControlThread
     * @request POST:/api/v1/threads/{threadId}/control
     * @response `200` `AgentThreadMessageQueueResponse` OK
     */
    controlThread: (
      threadId: string,
      data: AgentThreadControlSignalDto,
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadMessageQueueResponse, any>({
        path: `/api/v1/threads/${threadId}/control`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name UpdateThreadAutoMode
     * @request POST:/api/v1/threads/{threadId}/auto-mode
     * @response `200` `AgentThreadVo` OK
     */
    updateThreadAutoMode: (
      threadId: string,
      data: AgentThreadAutoModeDto,
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}/auto-mode`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name UploadArtifactFile
     * @request POST:/api/v1/threads/{threadId}/artifacts/file
     * @response `200` `UploadArtifactFileResponse` OK
     */
    uploadArtifactFile: (
      threadId: string,
      query: {
        artifact_type: UploadArtifactFileParamsArtifactType;
        /** @default "" */
        data?: string;
      },
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadArtifactFileResponse, any>({
        path: `/api/v1/threads/${threadId}/artifacts/file`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name GetThreadVoices
     * @request GET:/api/v1/threads/{threadId}/voices
     * @response `200` `JsonNode` OK
     */
    getThreadVoices: (threadId: string, params: RequestParams = {}) =>
      this.request<JsonNode, any>({
        path: `/api/v1/threads/${threadId}/voices`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ListTools
     * @request GET:/api/v1/threads/{threadId}/tools
     * @response `200` `Record<string,ToolInfoDto>` OK
     */
    listTools: (threadId: string, params: RequestParams = {}) =>
      this.request<Record<string, ToolInfoDto>, any>({
        path: `/api/v1/threads/${threadId}/tools`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ListRemoteToolCallTasks
     * @request GET:/api/v1/threads/{threadId}/tasks/rtc
     * @response `200` `(AgentThreadTask)[]` OK
     */
    listRemoteToolCallTasks: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadTask[], any>({
        path: `/api/v1/threads/${threadId}/tasks/rtc`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ExportTimeline
     * @request GET:/api/v1/threads/{threadId}/export-timeline
     * @response `200` `string` OK
     */
    exportTimeline: (threadId: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/threads/${threadId}/export-timeline`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name GetThreadArtifacts
     * @request GET:/api/v1/threads/{threadId}/artifacts
     * @response `200` `JsonNode` OK
     */
    getThreadArtifacts: (
      threadId: string,
      query?: {
        /** @default false */
        multi_version?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<JsonNode, any>({
        path: `/api/v1/threads/${threadId}/artifacts`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags agent-thread-controller
     * @name ListCommunityThreads
     * @request GET:/api/v1/threads/community
     * @response `200` `ListResponseByPageAgentThreadVo` OK
     */
    listCommunityThreads: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAgentThreadVo, any>({
        path: `/api/v1/threads/community`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  tasks = {
    /**
     * No description
     *
     * @tags task-controller
     * @name UpdateStatus
     * @request PUT:/api/v1/tasks/{taskId}/status
     * @response `200` `IDOnlyResponse` OK
     */
    updateStatus: (
      taskId: number,
      data: TaskUpdateStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/tasks/${taskId}/status`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags task-controller
     * @name GetTasks
     * @request GET:/api/v1/tasks
     * @response `200` `ListResponseByPageTaskView` OK
     */
    getTasks: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
        taskSource?: GetTasksParamsTaskSource;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageTaskView, any>({
        path: `/api/v1/tasks`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags task-controller
     * @name CreateTask
     * @request POST:/api/v1/tasks
     * @response `200` `TaskView` OK
     */
    createTask: (data: TaskCreateRequest, params: RequestParams = {}) =>
      this.request<TaskView, any>({
        path: `/api/v1/tasks`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags task-controller
     * @name TaskDetail
     * @request GET:/api/v1/tasks/{taskId}
     * @response `200` `TaskView` OK
     */
    taskDetail: (taskId: number, params: RequestParams = {}) =>
      this.request<TaskView, any>({
        path: `/api/v1/tasks/${taskId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags task-controller
     * @name DeleteTask
     * @request DELETE:/api/v1/tasks/{taskId}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteTask: (taskId: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/tasks/${taskId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags task-controller
     * @name TaskResult
     * @request GET:/api/v1/tasks/{taskId}/result
     * @response `200` `TaskResultView` OK
     */
    taskResult: (taskId: number, params: RequestParams = {}) =>
      this.request<TaskResultView, any>({
        path: `/api/v1/tasks/${taskId}/result`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags task-controller
     * @name GetM3U8Content
     * @request GET:/api/v1/tasks/{taskId}/chunks.m3u8
     * @response `200` `string` OK
     */
    getM3U8Content: (taskId: number, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/tasks/${taskId}/chunks.m3u8`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags task-controller
     * @name GetDebugInfo
     * @request GET:/api/v1/tasks/{id}/debug-info
     * @response `200` `TaskDebugInfoVO` OK
     */
    getDebugInfo: (id: number, params: RequestParams = {}) =>
      this.request<TaskDebugInfoVO, any>({
        path: `/api/v1/tasks/${id}/debug-info`,
        method: "GET",
        ...params,
      }),
  };
  projects = {
    /**
     * No description
     *
     * @tags project-controller
     * @name GetProject
     * @request GET:/api/v1/projects/{id}
     * @response `200` `ProjectView` OK
     */
    getProject: (id: number, params: RequestParams = {}) =>
      this.request<ProjectView, any>({
        path: `/api/v1/projects/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-controller
     * @name UpdateProject
     * @request PUT:/api/v1/projects/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    updateProject: (
      id: number,
      data: UpdateProjectRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/projects/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-controller
     * @name DeleteProject
     * @request DELETE:/api/v1/projects/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteProject: (id: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/projects/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-controller
     * @name ListProjects
     * @request GET:/api/v1/projects
     * @response `200` `ListResponseByPageProjectView` OK
     */
    listProjects: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageProjectView, any>({
        path: `/api/v1/projects`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-controller
     * @name CreateProject
     * @request POST:/api/v1/projects
     * @response `200` `IDOnlyResponse` OK
     */
    createProject: (data: CreateProjectRequest, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/projects`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-controller
     * @name UpdateCanvasJson
     * @request PATCH:/api/v1/projects/{id}/canvas
     * @response `200` `IDOnlyResponse` OK
     */
    updateCanvasJson: (id: number, data: string, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/projects/${id}/canvas`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  plans = {
    /**
     * No description
     *
     * @tags plan-controller
     * @name CancelUserPlan
     * @request PUT:/api/v1/plans/user/{priceId}/cancel
     * @response `200` `EmptySuccessResponse` OK
     */
    cancelUserPlan: (priceId: string, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/plans/user/${priceId}/cancel`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @tags plan-controller
     * @name QueryActivePlans
     * @request GET:/api/v1/plans
     * @response `200` `PlanPageVo` OK
     */
    queryActivePlans: (params: RequestParams = {}) =>
      this.request<PlanPageVo, any>({
        path: `/api/v1/plans`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags plan-controller
     * @name QueryUserPlan
     * @request GET:/api/v1/plans/user
     * @response `200` `UserPlanVo` OK
     */
    queryUserPlan: (params: RequestParams = {}) =>
      this.request<UserPlanVo, any>({
        path: `/api/v1/plans/user`,
        method: "GET",
        ...params,
      }),
  };
  objects = {
    /**
     * No description
     *
     * @tags objects-controller
     * @name GetObject
     * @request GET:/api/v1/objects/{id}
     * @response `200` `ObjectDTO` OK
     */
    getObject: (id: number, params: RequestParams = {}) =>
      this.request<ObjectDTO, any>({
        path: `/api/v1/objects/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags objects-controller
     * @name UpdateObject
     * @request PUT:/api/v1/objects/{id}
     * @response `200` `ObjectDTO` OK
     */
    updateObject: (id: number, data: ObjectVO, params: RequestParams = {}) =>
      this.request<ObjectDTO, any>({
        path: `/api/v1/objects/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags objects-controller
     * @name DeleteObject
     * @request DELETE:/api/v1/objects/{id}
     * @response `200` `void` OK
     */
    deleteObject: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/objects/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags objects-controller
     * @name ListObjects
     * @request GET:/api/v1/objects
     * @response `200` `(ObjectDTO)[]` OK
     */
    listObjects: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ObjectDTO[], any>({
        path: `/api/v1/objects`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags objects-controller
     * @name CreateObject
     * @request POST:/api/v1/objects
     * @response `200` `ObjectVO` OK
     */
    createObject: (data: ObjectVO, params: RequestParams = {}) =>
      this.request<ObjectVO, any>({
        path: `/api/v1/objects`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  payment = {
    /**
     * No description
     *
     * @tags stripe-webhook-receiver
     * @name Handle
     * @request POST:/payment/stripe/v2/webhook
     * @response `200` `JsonNode` OK
     */
    handle: (params: RequestParams = {}) =>
      this.request<JsonNode, any>({
        path: `/payment/stripe/v2/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags session-controller
     * @name CreatePortalSession
     * @request GET:/payment/sessions/portal
     * @response `200` `void` OK
     */
    createPortalSession: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/payment/sessions/portal`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags session-controller
     * @name CreateCheckoutSession
     * @request GET:/payment/sessions/checkout
     * @response `200` `void` OK
     */
    createCheckoutSession: (
      query: {
        priceId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/payment/sessions/checkout`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  share = {
    /**
     * No description
     *
     * @tags share-controller
     * @name ShareGeneration
     * @request POST:/api/v1/share
     * @response `200` `ShareVO` OK
     */
    shareGeneration: (
      data: ShareGenerationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShareVO, any>({
        path: `/api/v1/share`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags share-controller
     * @name GetGenerationShare
     * @request POST:/api/v1/share/{shareId}
     * @response `200` `ShareVO` OK
     */
    getGenerationShare: (shareId: number, params: RequestParams = {}) =>
      this.request<ShareVO, any>({
        path: `/api/v1/share/${shareId}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags share-controller
     * @name ShareTask
     * @request POST:/api/v1/share/tasks/{taskId}
     * @response `200` `Share` OK
     */
    shareTask: (taskId: number, params: RequestParams = {}) =>
      this.request<Share, any>({
        path: `/api/v1/share/tasks/${taskId}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags share-controller
     * @name CancelShare
     * @request DELETE:/api/v1/share/tasks/{taskId}
     * @response `200` `IDOnlyResponse` OK
     */
    cancelShare: (taskId: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/share/tasks/${taskId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags share-controller
     * @name GetGenerationSharePreview
     * @request GET:/api/v1/share/{shareId}/preview
     * @response `200` `string` OK
     */
    getGenerationSharePreview: (shareId: number, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/share/${shareId}/preview`,
        method: "GET",
        ...params,
      }),
  };
  reports = {
    /**
     * No description
     *
     * @tags report-controller
     * @name CreateReport
     * @request POST:/api/v1/reports
     * @response `200` `void` OK
     */
    createReport: (data: ReportCreateRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/reports`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags report-controller
     * @name GetReportReasons
     * @request GET:/api/v1/reports/tags
     * @response `200` `ReportTagsVo` OK
     */
    getReportReasons: (params: RequestParams = {}) =>
      this.request<ReportTagsVo, any>({
        path: `/api/v1/reports/tags`,
        method: "GET",
        ...params,
      }),
  };
  prompt = {
    /**
     * No description
     *
     * @tags prompt-controller
     * @name GetSuggestions
     * @request POST:/api/v1/prompt/suggestions
     * @response `200` `(PromptSuggestion)[]` OK
     */
    getSuggestions: (
      data: PromptSuggestionRequest,
      params: RequestParams = {},
    ) =>
      this.request<PromptSuggestion[], any>({
        path: `/api/v1/prompt/suggestions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags prompt-controller
     * @name EnhancePrompt
     * @request POST:/api/v1/prompt/enhance
     * @response `200` `PromptEnhancementResponse` OK
     */
    enhancePrompt: (
      data: PromptEnhancementRequest,
      params: RequestParams = {},
    ) =>
      this.request<PromptEnhancementResponse, any>({
        path: `/api/v1/prompt/enhance`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags prompt-controller
     * @name ListEnhancementTypes
     * @request GET:/api/v1/prompt/versions
     * @response `200` `(string)[]` OK
     */
    listEnhancementTypes: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v1/prompt/versions`,
        method: "GET",
        ...params,
      }),
  };
  promptEngineer = {
    /**
     * No description
     *
     * @tags pe-controller
     * @name RunCozeWorkflow
     * @request POST:/api/v1/prompt-engineer/run-coze-workflow
     * @response `200` `JSONObject` OK
     */
    runCozeWorkflow: (
      data: RunCoziWorkflowRequest,
      params: RequestParams = {},
    ) =>
      this.request<JSONObject, any>({
        path: `/api/v1/prompt-engineer/run-coze-workflow`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  platform = {
    /**
     * No description
     *
     * @tags feedback-controller
     * @name CreateCustomApiPackageRequest
     * @request POST:/api/v1/platform/feedback/custom-api-package-request
     * @response `200` `IDOnlyResponse` OK
     */
    createCustomApiPackageRequest: (
      data: CustomApiPackageRequestVo,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/platform/feedback/custom-api-package-request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name GetApiKeyList
     * @request GET:/api/v1/platform/api-keys
     * @response `200` `(ApiKeyVo)[]` OK
     */
    getApiKeyList: (params: RequestParams = {}) =>
      this.request<ApiKeyVo[], any>({
        path: `/api/v1/platform/api-keys`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name CreateApiKey
     * @request POST:/api/v1/platform/api-keys
     * @response `200` `ApiKey` OK
     */
    createApiKey: (data: ApiKeyRequest, params: RequestParams = {}) =>
      this.request<ApiKey, any>({
        path: `/api/v1/platform/api-keys`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-order-controller
     * @name GetPlatformOrders
     * @request GET:/api/v1/platform/orders
     * @response `200` `ListResponseByPagePlatformOrderVo` OK
     */
    getPlatformOrders: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPagePlatformOrderVo, any>({
        path: `/api/v1/platform/orders`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-credit-controller
     * @name GetPlatformCreditUsage
     * @request GET:/api/v1/platform/credits/usage
     * @response `200` `PlatformOrganizationCreditVo` OK
     */
    getPlatformCreditUsage: (params: RequestParams = {}) =>
      this.request<PlatformOrganizationCreditVo, any>({
        path: `/api/v1/platform/credits/usage`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-credit-controller
     * @name GetPlatformCreditTransaction
     * @request GET:/api/v1/platform/credits/transactions
     * @response `200` `ListResponseByPageUserCreditTransactionVo` OK
     */
    getPlatformCreditTransaction: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageUserCreditTransactionVo, any>({
        path: `/api/v1/platform/credits/transactions`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-credit-controller
     * @name GetPlatformCreditPackages
     * @request GET:/api/v1/platform/credits/packages
     * @response `200` `(PlatformCreditPackage)[]` OK
     */
    getPlatformCreditPackages: (params: RequestParams = {}) =>
      this.request<PlatformCreditPackage[], any>({
        path: `/api/v1/platform/credits/packages`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name DeleteApiKey
     * @request DELETE:/api/v1/platform/api-keys/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteApiKey: (id: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/platform/api-keys/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notification
     * @name GetSubscription
     * @request GET:/api/v1/notification/subscribe
     * @response `200` `SubscriptionView` OK
     */
    getSubscription: (params: RequestParams = {}) =>
      this.request<SubscriptionView, any>({
        path: `/api/v1/notification/subscribe`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name Subscribe
     * @request POST:/api/v1/notification/subscribe
     * @response `200` `SubscriptionView` OK
     */
    subscribe: (data: SubscribeRequest, params: RequestParams = {}) =>
      this.request<SubscriptionView, any>({
        path: `/api/v1/notification/subscribe`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name Unsubscribe
     * @request DELETE:/api/v1/notification/subscribe
     * @response `200` `IDOnlyResponse` OK
     */
    unsubscribe: (params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/notification/subscribe`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get the VAPID public key needed for web push subscription
     *
     * @tags Notification
     * @name GetVapidPublicKey
     * @summary Get VAPID public key
     * @request GET:/api/v1/notification/vapid-public-key
     * @response `200` `VapidPublicKeyView` OK
     */
    getVapidPublicKey: (params: RequestParams = {}) =>
      this.request<VapidPublicKeyView, any>({
        path: `/api/v1/notification/vapid-public-key`,
        method: "GET",
        ...params,
      }),
  };
  live = {
    /**
     * No description
     *
     * @tags live-controller
     * @name StopStream
     * @request POST:/api/v1/live/streams/{streamId}/stop
     * @response `200` `boolean` OK
     */
    stopStream: (streamId: number, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/live/streams/${streamId}/stop`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags live-controller
     * @name LiveGenerate
     * @request POST:/api/v1/live/generate
     * @response `200` `LiveGenerateResponse` OK
     */
    liveGenerate: (data: LiveGenerateRequest, params: RequestParams = {}) =>
      this.request<LiveGenerateResponse, any>({
        path: `/api/v1/live/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags live-controller
     * @name GetLiveStatus
     * @request GET:/api/v1/live/status
     * @response `200` `LiveStatusResponse` OK
     */
    getLiveStatus: (params: RequestParams = {}) =>
      this.request<LiveStatusResponse, any>({
        path: `/api/v1/live/status`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags live-controller
     * @name GetPreview
     * @request GET:/api/v1/live/preview/{streamId}
     * @response `200` `string` OK
     */
    getPreview: (streamId: number, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/live/preview/${streamId}`,
        method: "GET",
        ...params,
      }),
  };
  invitations = {
    /**
     * No description
     *
     * @tags invitation-code-controller
     * @name VerifyPermission
     * @request POST:/api/v1/invitations/verify
     * @response `200` `InvitationCodeResponse` OK
     */
    verifyPermission: (
      data: VerifyPermissionRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/verify`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitation-code-controller
     * @name UseInvitationCode
     * @request POST:/api/v1/invitations/use
     * @response `200` `InvitationCodeResponse` OK
     */
    useInvitationCode: (
      data: UseInvitationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/use`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitation-code-controller
     * @name UnbindInvitationCode
     * @request POST:/api/v1/invitations/unbind
     * @response `200` `InvitationCodeResponse` OK
     */
    unbindInvitationCode: (
      data: UnbindInvitationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/unbind`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitation-code-controller
     * @name GenerateInvitationCode
     * @request POST:/api/v1/invitations/generate
     * @response `200` `InvitationCodeResponse` OK
     */
    generateInvitationCode: (
      data: GenerateInvitationCodeRequest[],
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  infer = {
    /**
     * No description
     *
     * @tags infer-event-controller
     * @name ProcessInferEvent
     * @request POST:/api/v1/infer/events
     * @response `200` `void` OK
     */
    processInferEvent: (data: InferEvent, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/infer/events`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  images = {
    /**
     * No description
     *
     * @tags image-controller
     * @name CreateImage
     * @request POST:/api/v1/images
     * @response `200` `CreateImageDTO` OK
     */
    createImage: (data: CreateImageRequest, params: RequestParams = {}) =>
      this.request<CreateImageDTO, any>({
        path: `/api/v1/images`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags image-controller
     * @name ListImages
     * @request POST:/api/v1/images/list
     * @response `200` `ListResponseByPageImageDTO` OK
     */
    listImages: (data: ListImageRequest, params: RequestParams = {}) =>
      this.request<ListResponseByPageImageDTO, any>({
        path: `/api/v1/images/list`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags image-controller
     * @name GetImage
     * @request GET:/api/v1/images/get
     * @response `200` `ImageDTO` OK
     */
    getImage: (
      query: {
        /** @format int64 */
        taskId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDTO, any>({
        path: `/api/v1/images/get`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  generations = {
    /**
     * No description
     *
     * @tags generation-controller
     * @name ListGenerations
     * @request GET:/api/v1/generations
     * @response `200` `ListResponseByPageGenerationVO` OK
     */
    listGenerations: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
        /** @default [] */
        taskSources?: ListGenerationsParamsTaskSources[];
        /** @default [] */
        taskTypes?: ListGenerationsParamsTaskTypes[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageGenerationVO, any>({
        path: `/api/v1/generations`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name Generate
     * @request POST:/api/v1/generations
     * @response `200` `GenerationResponseVO` OK
     */
    generate: (data: GenerationRequestVO, params: RequestParams = {}) =>
      this.request<GenerationResponseVO, any>({
        path: `/api/v1/generations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name CreatePipeline
     * @request POST:/api/v1/generations/pipeline
     * @response `200` `PipelineResponseVO` OK
     */
    createPipeline: (data: PipelineRequestVO, params: RequestParams = {}) =>
      this.request<PipelineResponseVO, any>({
        path: `/api/v1/generations/pipeline`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name PerformerGenerate
     * @request POST:/api/v1/generations/performer
     * @response `200` `GenerationResponseVO` OK
     */
    performerGenerate: (
      data: GenerationRequestVO,
      params: RequestParams = {},
    ) =>
      this.request<GenerationResponseVO, any>({
        path: `/api/v1/generations/performer`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name ListGenerationsByRequest
     * @request POST:/api/v1/generations/list
     * @response `200` `ListResponseByPageGenerationVO` OK
     */
    listGenerationsByRequest: (
      data: ListGenerationRequest,
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageGenerationVO, any>({
        path: `/api/v1/generations/list`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name GenerateImages
     * @request POST:/api/v1/generations/images
     * @response `200` `(ImageGenerationResponseVO)[]` OK
     */
    generateImages: (
      data: ImageGenerationRequestVO,
      params: RequestParams = {},
    ) =>
      this.request<ImageGenerationResponseVO[], any>({
        path: `/api/v1/generations/images`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name GetGenerationDetail
     * @request GET:/api/v1/generations/{id}
     * @response `200` `GenerationDetailResponseVO` OK
     */
    getGenerationDetail: (
      id: number,
      query: {
        chunks: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GenerationDetailResponseVO, any>({
        path: `/api/v1/generations/${id}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name StreamingDownloadGenerationChunks
     * @request GET:/api/v1/generations/streaming-download
     * @response `200` `StreamingResponseBody` OK
     */
    streamingDownloadGenerationChunks: (
      query: {
        requests: string;
        filename?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StreamingResponseBody, any>({
        path: `/api/v1/generations/streaming-download`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name GetGenerationChunks
     * @request GET:/api/v1/generations/preview
     * @response `200` `string` OK
     */
    getGenerationChunks: (
      query: {
        requests: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/generations/preview`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags generation-controller
     * @name GetPipelineDetail
     * @request GET:/api/v1/generations/pipeline/{id}
     * @response `200` `PipelineDetailResponseVO` OK
     */
    getPipelineDetail: (id: number, params: RequestParams = {}) =>
      this.request<PipelineDetailResponseVO, any>({
        path: `/api/v1/generations/pipeline/${id}`,
        method: "GET",
        ...params,
      }),
  };
  favorites = {
    /**
     * No description
     *
     * @tags favorite-controller
     * @name FavoriteTasks
     * @request GET:/api/v1/favorites
     * @deprecated
     * @response `200` `ListResponseByPageTaskView` OK
     */
    favoriteTasks: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageTaskView, any>({
        path: `/api/v1/favorites`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags favorite-controller
     * @name AddFavorite
     * @request POST:/api/v1/favorites
     * @deprecated
     * @response `200` `IDOnlyResponse` OK
     */
    addFavorite: (data: AddFavoriteRequest, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/favorites`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags favorite-controller
     * @name AddFavoriteTask
     * @request POST:/api/v1/favorites/tasks/
     * @response `200` `IDOnlyResponse` OK
     */
    addFavoriteTask: (
      query: {
        /** @format int64 */
        taskId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/favorites/tasks/`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags favorite-controller
     * @name AddFavoriteAsset
     * @request POST:/api/v1/favorites/assets/
     * @response `200` `IDOnlyResponse` OK
     */
    addFavoriteAsset: (
      query: {
        /** @format int64 */
        assetId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/favorites/assets/`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags favorite-controller
     * @name GetFavoriteTasks
     * @request GET:/api/v1/favorites/tasks
     * @response `200` `ListResponseByPageTaskView` OK
     */
    getFavoriteTasks: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageTaskView, any>({
        path: `/api/v1/favorites/tasks`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags favorite-controller
     * @name GetFavoriteAssets
     * @request GET:/api/v1/favorites/assets
     * @response `200` `ListResponseByPageAssetView` OK
     */
    getFavoriteAssets: (
      query?: {
        /** @default [] */
        types?: GetFavoriteAssetsParamsTypes[];
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAssetView, any>({
        path: `/api/v1/favorites/assets`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags favorite-controller
     * @name DeleteFavoriteTask
     * @request DELETE:/api/v1/favorites/tasks/{taskId}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteFavoriteTask: (taskId: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/favorites/tasks/${taskId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags favorite-controller
     * @name DeleteFavoriteAsset
     * @request DELETE:/api/v1/favorites/assets/{assetId}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteFavoriteAsset: (assetId: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/favorites/assets/${assetId}`,
        method: "DELETE",
        ...params,
      }),
  };
  configs = {
    /**
     * No description
     *
     * @tags config-controller
     * @name SetConfig
     * @request POST:/api/v1/configs/set
     * @response `200` `ConfigResponse` OK
     */
    setConfig: (data: SetConfigRequest, params: RequestParams = {}) =>
      this.request<ConfigResponse, any>({
        path: `/api/v1/configs/set`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags config-controller
     * @name GetConfig
     * @request POST:/api/v1/configs/get
     * @response `200` `ConfigResponse` OK
     */
    getConfig: (data: GetConfigRequest, params: RequestParams = {}) =>
      this.request<ConfigResponse, any>({
        path: `/api/v1/configs/get`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags auth-controller
     * @name CheckAuth
     * @request POST:/api/v1/auth/check
     * @response `200` `CheckAuthVo` OK
     */
    checkAuth: (
      query: {
        authCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CheckAuthVo, any>({
        path: `/api/v1/auth/check`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags o-auth-2-controller
     * @name GoogleLogin
     * @request GET:/auth/oauth2/google
     * @response `200` `void` OK
     */
    googleLogin: (
      query?: {
        invite_code?: string;
        function?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/google`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags o-auth-2-controller
     * @name DiscordLogin
     * @request GET:/auth/oauth2/discord
     * @response `200` `void` OK
     */
    discordLogin: (
      query?: {
        invite_code?: string;
        function?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/discord`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags o-auth-2-controller
     * @name GoogleCallback
     * @request GET:/auth/oauth2/callback/google
     * @response `200` `void` OK
     */
    googleCallback: (
      query?: {
        code?: string;
        error?: string;
        state?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/callback/google`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags o-auth-2-controller
     * @name DiscordCallback
     * @request GET:/auth/oauth2/callback/discord
     * @response `200` `void` OK
     */
    discordCallback: (
      query?: {
        code?: string;
        error?: string;
        state?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/callback/discord`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags o-auth-2-controller
     * @name Logout
     * @request GET:/auth/logout
     * @response `200` `void` OK
     */
    logout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/logout`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth-controller
     * @name QueryUserAuth
     * @request GET:/api/v1/auth/user/get
     * @response `200` `AuthVo` OK
     */
    queryUserAuth: (params: RequestParams = {}) =>
      this.request<AuthVo, any>({
        path: `/api/v1/auth/user/get`,
        method: "GET",
        ...params,
      }),
  };
  assets = {
    /**
     * No description
     *
     * @tags asset-controller
     * @name ListAssets
     * @request GET:/api/v1/assets
     * @response `200` `ListResponseByPageAssetView` OK
     */
    listAssets: (
      query?: {
        /** @default [] */
        sources?: ListAssetsParamsSources[];
        /** @default [] */
        types?: ListAssetsParamsTypes[];
        /** @default "" */
        search?: string;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAssetView, any>({
        path: `/api/v1/assets`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags asset-controller
     * @name UploadAsset
     * @request POST:/api/v1/assets
     * @response `200` `AssetView` OK
     */
    uploadAsset: (
      data: {
        /** @format binary */
        file: File;
      },
      query?: {
        /** @default "" */
        fileName?: string;
        /** @default "Upload" */
        source?: UploadAssetParamsSource;
        /** @default true */
        isArtifacts?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetView, any>({
        path: `/api/v1/assets`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags asset-controller
     * @name VideoModerationCallback
     * @request POST:/api/v1/assets/video-moderation-callback
     * @response `200` `IDOnlyResponse` OK
     */
    videoModerationCallback: (
      query: {
        request: ModerateVideoCallbackRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/assets/video-moderation-callback`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags text-to-speech-controller
     * @name TextToSpeech
     * @request POST:/api/v1/assets/text-to-speech
     * @response `200` `AssetView` OK
     */
    textToSpeech: (data: TextToSpeechRequest, params: RequestParams = {}) =>
      this.request<AssetView, any>({
        path: `/api/v1/assets/text-to-speech`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags asset-controller
     * @name MgetAssets
     * @request GET:/api/v1/assets/mget
     * @response `200` `Record<string,AssetView>` OK
     */
    mgetAssets: (
      query: {
        ids: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, AssetView>, any>({
        path: `/api/v1/assets/mget`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags asset-controller
     * @name DeleteAssetById
     * @request DELETE:/api/v1/assets/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteAssetById: (id: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/assets/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  agent = {
    /**
     * No description
     *
     * @tags Agent Files
     * @name InitMultipartUpload
     * @request POST:/api/v1/agent/files/multipart-init
     * @response `200` `MultipartUploadVO` OK
     */
    initMultipartUpload: (
      data: MultipartUploadInitRequest,
      params: RequestParams = {},
    ) =>
      this.request<MultipartUploadVO, any>({
        path: `/api/v1/agent/files/multipart-init`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent Files
     * @name CompleteMultipartUpload
     * @request POST:/api/v1/agent/files/multipart-complete
     * @response `200` `MultipartUploadVO` OK
     */
    completeMultipartUpload: (
      data: MultipartUploadCompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<MultipartUploadVO, any>({
        path: `/api/v1/agent/files/multipart-complete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Receive event callbacks from Agent
     *
     * @tags Agent Events
     * @name ReceiveEvent
     * @summary Receive agent event callback
     * @request POST:/api/v1/agent/events
     * @response `200` `Record<string,boolean>` OK
     */
    receiveEvent: (data: AgentEventRequest, params: RequestParams = {}) =>
      this.request<Record<string, boolean>, any>({
        path: `/api/v1/agent/events`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  admin = {
    /**
     * No description
     *
     * @tags admin-user-controller
     * @name UnbanUser
     * @request POST:/api/v1/admin/user/unban
     * @response `200` `GeneralResponse` OK
     */
    unbanUser: (data: AdminBanUserRequest, params: RequestParams = {}) =>
      this.request<GeneralResponse, any>({
        path: `/api/v1/admin/user/unban`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-user-controller
     * @name AddSuperAdminUser
     * @request POST:/api/v1/admin/user/super/add
     * @response `200` `GeneralResponse` OK
     */
    addSuperAdminUser: (data: string, params: RequestParams = {}) =>
      this.request<GeneralResponse, any>({
        path: `/api/v1/admin/user/super/add`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-user-controller
     * @name BanUser
     * @request POST:/api/v1/admin/user/ban
     * @response `200` `GeneralResponse` OK
     */
    banUser: (data: AdminBanUserRequest, params: RequestParams = {}) =>
      this.request<GeneralResponse, any>({
        path: `/api/v1/admin/user/ban`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-plan-controller
     * @name GrantMembership
     * @request POST:/api/v1/admin/plans/grant-membership
     * @response `200` `GrantMembershipResultResponse` OK
     */
    grantMembership: (
      data: GrantMembershipRequest,
      params: RequestParams = {},
    ) =>
      this.request<GrantMembershipResultResponse, any>({
        path: `/api/v1/admin/plans/grant-membership`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-credit-controller
     * @name IssueUserCredit
     * @request POST:/api/v1/admin/credit/operate/user
     * @response `200` `void` OK
     */
    issueUserCredit: (
      query: {
        userIds: string[];
        /** @format int32 */
        amount: number;
        creditType: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/credit/operate/user`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-credit-controller
     * @name IssueOrgCredit
     * @request POST:/api/v1/admin/credit/operate/org
     * @response `200` `void` OK
     */
    issueOrgCredit: (
      query: {
        orgIds: string[];
        /** @format int32 */
        amount: number;
        creditType: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/credit/operate/org`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-plan-controller
     * @name GetUserPlanInfo
     * @request GET:/api/v1/admin/plans/user/{userId}
     * @response `200` `UserPlanInfoResponse` OK
     */
    getUserPlanInfo: (userId: number, params: RequestParams = {}) =>
      this.request<UserPlanInfoResponse, any>({
        path: `/api/v1/admin/plans/user/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-plan-controller
     * @name GetUserPlanInfoByEmail
     * @request GET:/api/v1/admin/plans/user/by-email
     * @response `200` `UserPlanInfoResponse` OK
     */
    getUserPlanInfoByEmail: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserPlanInfoResponse, any>({
        path: `/api/v1/admin/plans/user/by-email`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  operation = {
    /**
     * No description
     *
     * @tags operation-controller
     * @name CreateTempUserAccount
     * @request GET:/operation/create-temp-user-account
     * @response `200` `(TempUserInfo)[]` OK
     */
    createTempUserAccount: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        count?: number;
        /** @default false */
        addToLoginWhiteList?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TempUserInfo[], any>({
        path: `/operation/create-temp-user-account`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  system = {
    /**
     * No description
     *
     * @tags system-controller
     * @name GetSystemConfig
     * @request GET:/api/v1/system/config
     * @response `200` `SystemConfigView` OK
     */
    getSystemConfig: (params: RequestParams = {}) =>
      this.request<SystemConfigView, any>({
        path: `/api/v1/system/config`,
        method: "GET",
        ...params,
      }),
  };
  gallery = {
    /**
     * No description
     *
     * @tags gallery-controller
     * @name GetTasks1
     * @request GET:/api/v1/gallery/tasks
     * @response `200` `ListResponseByPageTaskView` OK
     */
    getTasks1: (
      query?: {
        /** @default true */
        all?: boolean;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageTaskView, any>({
        path: `/api/v1/gallery/tasks`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  credits = {
    /**
     * No description
     *
     * @tags credit-controller
     * @name GetUserCredit
     * @request GET:/api/v1/credits/user
     * @response `200` `UserCreditVo` OK
     */
    getUserCredit: (params: RequestParams = {}) =>
      this.request<UserCreditVo, any>({
        path: `/api/v1/credits/user`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags credit-controller
     * @name GetUserCreditTransaction
     * @request GET:/api/v1/credits/transaction
     * @response `200` `UserCreditTransactionPageVo` OK
     */
    getUserCreditTransaction: (
      query: {
        /** @format int64 */
        continuationToken?: number;
        /** @format int32 */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserCreditTransactionPageVo, any>({
        path: `/api/v1/credits/transaction`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags credit-controller
     * @name GetCredit
     * @request GET:/api/v1/credits/package
     * @response `200` `CreditPackagePageVo` OK
     */
    getCredit: (params: RequestParams = {}) =>
      this.request<CreditPackagePageVo, any>({
        path: `/api/v1/credits/package`,
        method: "GET",
        ...params,
      }),
  };
  actuator = {
    /**
     * No description
     *
     * @tags actuator-controller
     * @name Readiness
     * @request GET:/actuator/readiness
     * @response `200` `string` OK
     */
    readiness: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/actuator/readiness`,
        method: "GET",
        ...params,
      }),
  };
}
